module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-center-content"
  }, [_c('h4', [_vm._v("有声播讲 技巧")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("1.  如何咬字发音更清晰？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/16370997/sound/10128743/",
      "target": "_blank"
    }
  }, [_vm._v("【播音入门】让你远离咬字不清的烦恼（张熙棠）")])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("2.  如何掌握用气发声？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/16370997/sound/10224229/",
      "target": "_blank"
    }
  }, [_vm._v("【播音入门】让你掌握用气发声秘籍（张熙棠）")])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("3.  如何突破方言普通话瓶颈？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/16370997/sound/10291170/",
      "target": "_blank"
    }
  }, [_vm._v("【播音入门】练好嘴皮子，从正确读绕口令开始（卡恩老师）")])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("4.  如何变读为说？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/16370997/sound/10386858/",
      "target": "_blank"
    }
  }, [_vm._v("【播音入门】“推倒”自己心仪的有声书，有声播讲从“读”变“说”开始（全勇老师）")])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("5.  如何讲好旁白？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/16370997/sound/10420739/",
      "target": "_blank"
    }
  }, [_vm._v("【有声入门】有声播讲的旁白技法（全勇老师）")])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("6.  如何扮演角色？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/16370997/sound/10577304/",
      "target": "_blank"
    }
  }, [_vm._v("【播音入门】有声播讲的台词技巧，精准塑造人物形象（全勇老师）")])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("7.  如何防止喷麦？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("防止受到呼吸声，自然环境声音的干扰。建议使用耳机录制，并且在耳机麦克风上盖上一层湿纸巾即可。起到麦克风保护套的作用，这样即可防止带来外界的干扰。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29a4a2fc!./~/vue-loader/lib/selector.js?type=template&index=0!./views/anchor/helpCenter/AnnounceTips.vue
// module id = 367
// module chunks = 0